<template>
  <div class="clearfix">
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["578"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.width"
          class="input-w"
        />
        <a-select
          v-model="datas.unit"
          class="input-w-px"
        >
          <a-select-option :value="1">
            px
          </a-select-option>
          <a-select-option :value="2">
            %
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["349"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.height"
          class="input-normal"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["1689"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input-number
          v-model="datas.paddingLeftAndRight"
          class="input-normal"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["28"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.backgroundColor"
          class="input-color"
        />
        <color-picker
          key="1"
          :color="datas.backgroundColor"
          @setColor="setBgColor"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ getLang() === 'en' ? 'Hover':'hover边框' }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.hoverBorderColor"
          class="input-color"
        />
        <color-picker
          key="2"
          :color="datas.hoverBorderColor"
          @setColor="setBorderColor"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["46"]') }}：</span>
      <div class="input-select-item-cell">
        <a-select
          v-model="datas.borderStyle"
          class="select-normal"
        >
          <a-select-option :value="1">
            {{ $t('message["1154"]') }}
          </a-select-option>
          <a-select-option :value="2">
            {{ $t('message["208"]') }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["1528"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input-number
          v-model="datas.borderRadius"
          class="input-normal"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from './ColorPicker'
import { getLang } from '@/lib/storage'
export default {
  components: {
    ColorPicker
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    datas () {
      return this.itemData.inputAndSelect
    }
  },
  methods: {
    getLang,
    setBorderColor (c) {
      this.datas.hoverBorderColor = c
    },
    setBgColor (c) {
      this.datas.backgroundColor = c
    },
    changeW (e) {
      this.datas.width = e.target.value
    }
  }
}
</script>
